import { render, staticRenderFns } from "./DependentView.vue?vue&type=template&id=956d16de&"
import script from "./DependentView.vue?vue&type=script&lang=js&"
export * from "./DependentView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports